// Constanst to be used by TEST AUTOMATION
export enum testingEnum {
    ValidateOkToastMsg = "ValidateOkToastMsg",
    maxResultsRetrievedToastMsg = "maxResultsRetrievedToastMsg",
    noResultsFoundToastMsg = "noResultsFoundToastMsg",
    sectionResetToastMsg = "sectionResetToastMsg",
    appResetToastMsg = "appResetToastMsg"
} 